import { DmsSystem } from "@/api-schema-enums";
import i18next from "i18next";
import { ReactElement } from "react";
import { BaseFilterProps, Filter, FilterData } from "../_types";
import { FilterComponent } from "../base-filter";

const EXCLUDED_IDENTIFIER_TYPES: DmsSystem[] = [DmsSystem.Sap, DmsSystem.AlphartisInternal];

export function getCustomerIdentifierTypeOptions(
  excludedTypes: readonly DmsSystem[] = [],
): { id: DmsSystem; name: string }[] {
  return Object.values(DmsSystem)
    .filter((type) => !EXCLUDED_IDENTIFIER_TYPES.includes(type) && !excludedTypes.includes(type))
    .map((type) => ({ id: type, name: i18next.t(`masterdata:CustomerIdentifierType${type}`) }));
}

export class CustomerIdentifierTypeFilter extends Filter<
  { customerIdentifierType?: DmsSystem[] },
  Record<string, never>
> {
  readonly id: string = "customerIdentifierType";
  readonly labelSingular = "masterdata:IdentifierType";
  readonly labelPlural = "masterdata:IdentifierType";
  readonly placeholder = "masterdata:SelectIdentifierType";
  readonly searchPlaceholder = "masterdata:SearchIdentifierType";
  readonly emptyText = "masterdata:NoIdentifierTypeFound";
  body = {};
  parameters = {};
  readonly excludedTypes: readonly DmsSystem[];

  constructor({ id, excludedTypes = [] }: { id?: string; excludedTypes?: readonly DmsSystem[] } = {}) {
    super();
    if (id) this.id = id;
    this.excludedTypes = excludedTypes;
  }

  getData(): FilterData {
    return {
      options: getCustomerIdentifierTypeOptions(this.excludedTypes),
      isLoading: false,
      error: null,
    };
  }

  render(props: BaseFilterProps): ReactElement {
    return <FilterComponent filter={this} {...props} />;
  }
}
